module.exports = __webpack_public_path__ + "media/images/div_lens/div-neurodivergent-ed57cfb858fe63e047fc45c3614891bc.png";